import React from 'react';

export default function ScrollingBanner() {
  const text = "Découvrez comment vous pouvez contribuer à la mise en route des îlots de développement auto-gérés en RD Congo.";
  return (
    <div className="overflow-hidden bg-[#4A6B48] text-white py-2 border-y border-[#3B5539]" data-testid="scrolling-banner">
      <div className="scrolling-track flex whitespace-nowrap" aria-hidden="false">
        {/* Two copies so the marquee loops seamlessly */}
        <span className="px-12 text-sm font-bold tracking-wide inline-block">{text}</span>
        <span className="px-12 text-sm font-bold tracking-wide inline-block">{text}</span>
        <span className="px-12 text-sm font-bold tracking-wide inline-block">{text}</span>
        <span className="px-12 text-sm font-bold tracking-wide inline-block">{text}</span>
      </div>
    </div>
  );
}
